import { apiFetch, fetchWithAuthRetry } from './client'

export type HealthDigestRunRow = {
  digest_date: string
  collected_at: string
  sent_at: string | null
  log_only: boolean
  subject: string | null
  flags_json: string[]
}

export async function previewHealthDigest(date: string): Promise<string> {
  const q = new URLSearchParams({ date })
  const res = await fetchWithAuthRetry(`/api/email/health-digest/preview?${q}`, {
    headers: { Accept: 'text/html' },
  })
  if (!res.ok) throw new Error(`Preview failed (${res.status})`)
  return res.text()
}

export async function sendHealthDigestNow(date: string, force = false) {
  return apiFetch<{ data: Record<string, unknown> }>(
    'POST',
    '/api/admin/health-digest/send',
    { date, force },
  )
}

export async function fetchHealthDigestRuns(): Promise<HealthDigestRunRow[]> {
  const res = await apiFetch<{ data: HealthDigestRunRow[] }>(
    'GET',
    '/api/admin/health-digest/runs',
  )
  return res.data ?? []
}
